<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="企业名称：">
            <el-input clearable v-model="filterForm.companyName" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="岗位名称：">
            <el-input clearable v-model="filterForm.aca112" placeholder="请输入岗位名称"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2_" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler" />

    <el-dialog
      title="导入提示"
      :close-on-click-modal="false"
      :visible.sync="isShowImportTip"
      :append-to-body="true"
      width="1000px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>
  </div>
</template>

<script>
import enum_shengting from '@/publicData/enum_shengting'
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
import AreaPicker from '@/components/AreaPicker_3'
// import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation },
  data() {
    return {
      sign: 'shengting_gangwei',
      dialogTitle: '岗位信息',
      fileName: 'gangweixinxi',
      importTipKey: 'aca112',
      importTiplabel: '岗位名称',

      enum_shengting: enum_shengting,

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },

        // { key: 'hire_id', label: '外部系统主键' },
        // { key: 'cid', label: '外部系统企业主键' },
        { key: 'companyName', label: '企业名称', fixed: true },
        { key: 'aca112', label: '岗位名称', fixed: true },
        { key: 'acb22a', label: '岗位描述' },
        { key: 'aca111', label: '职业(工种)' },
        { key: 'aac015', label: '国家职业资格等级(工人技术等级)' },
        { key: 'aac183', label: '所学专业' },
        { key: 'aac011', label: '学历' },
        { key: 'aac014', label: '职称(专业技术职务)' },
        { key: 'acb240', label: '招聘人数' },
        // { key: 'aab301', label: '工作地点行政区划代码' },
        { key: 'acb202', label: '工作地点' },
        { key: 'acb239', label: '工作性质' },
        // { key: 'acb221', label: '最低年龄' },
        // { key: 'acb222', label: '最高年龄' },
        // { key: 'aac010', label: '户口所在地(招收区域限制)' },
        // { key: 'acb241', label: '月薪下限' },
        // { key: 'acb242', label: '月薪上限' },
        // { key: 'acb207', label: '面试日期' },
        // { key: 'acb20c', label: '面试地点' },
        // { key: 'aae004', label: '联系人' },
        // { key: 'aae005', label: '联系电话' },
        // { key: 'aae397', label: '发布日期' },
        // { key: 'aae398', label: '到期日期' },
        // { key: 'ace751', label: '审核状态' },
        // { key: 'ace752', label: '发布状态' },
        // { key: 'ace760', label: '原始网页地址(url)' },
        // { key: 'aae013', label: '备注' },
        { key: 'ace762', label: '是否有效' },
        // { key: 'acb21d', label: '招聘男性人数' },
        // { key: 'acb21e', label: '招聘女性人数' },
        // { key: 'acb246', label: '工作环境' },
        // { key: 'Aac024', label: '政治面貌' },
        // { key: 'aac034', label: '身高' },
        // { key: 'aac035', label: '体重' },
        // { key: 'aac036', label: '视力' },
        // { key: 'aac038', label: '外语语种' },
        // { key: 'aac175', label: '外语水平' },
        // { key: 'aac179', label: '计算机水平' },
        // { key: 'acc217', label: '从业年数' },
        // { key: 'acb247', label: '试用期' },
        // { key: 'acb243', label: '试用期月工资档次' },
        // { key: 'acb244', label: '其他待遇' },
        { key: 'acb228', label: '提供住宿标识' },
        { key: 'acb245', label: '提供住房公积金标识' },
        { key: 'status_', label: '状态' },
        { key: 'importError', label: '失败原因' },
      ],
    }
  },
  computed: {
    importAction() {
      return this.$api.baseUrl + '/user/sync/job/' + this.userInfo.areaId
    },
    formItems() {
      return [
        // { type: 'text', key: 'hire_id', label: '外部系统主键' },
        // { type: 'text', key: 'cid', label: '外部系统企业主键' },
        { type: 'text', key: 'companyName', label: '企业名称' },
        { type: 'text', key: 'aca112', label: '岗位名称' },
        { type: 'text', key: 'acb22a', label: '岗位描述' },
        { type: 'select_s', key: 'aca111', label: '职业(工种)', options: this.enum_shengting.zhiyegongzhong },
        { type: 'select_s', key: 'aac015', label: '国家职业资格等级(工人技术等级)', options: this.enum_shengting.guojiazhiyedengji },
        { type: 'select_s', key: 'aac183', label: '所学专业', options: this.enum_shengting.suoxuezhuanye },
        { type: 'select_s', key: 'aac011', label: '学历', options: this.enum_shengting.xueli },
        { type: 'select_s', key: 'aac014', label: '职称(专业技术职务)', options: this.enum_shengting.zhicheng },
        { type: 'text', key: 'acb240', label: '招聘人数' },
        // { type: 'text', key: 'aab301', label: '工作地点行政区划代码' },
        { type: 'text', key: 'acb202', label: '工作地点' },
        { type: 'select_s', key: 'acb239', label: '工作性质', options: this.enum_shengting.gongzuoxingzhi },
        { type: 'text', key: 'acb221', label: '最低年龄' },
        { type: 'text', key: 'acb222', label: '最高年龄' },
        { type: 'text', key: 'aac010', label: '户口所在地(招收区域限制)' },
        { type: 'text', key: 'acb241', label: '月薪下限' },
        { type: 'text', key: 'acb242', label: '月薪上限' },
        { type: 'text', key: 'acb207', label: '面试日期' },
        { type: 'text', key: 'acb20c', label: '面试地点' },
        { type: 'text', key: 'aae004', label: '联系人' },
        { type: 'text', key: 'aae005', label: '联系电话' },
        { type: 'text', key: 'aae397', label: '发布日期' },
        { type: 'text', key: 'aae398', label: '到期日期' },
      ]
    },
    formItems2() {
      return [
        { type: 'select_s', key: 'ace751', label: '审核状态', options: this.enum_shengting.shenhezhuangtai },
        { type: 'select_s', key: 'ace752', label: '发布状态', options: this.enum_shengting.shifou },
        { type: 'text', key: 'ace760', label: '原始网页地址(url)' },
        { type: 'text', key: 'aae013', label: '备注' },
        { type: 'select_s', key: 'ace762', label: '是否有效', options: this.enum_shengting.youxiaoxing },
        { type: 'text', key: 'acb21d', label: '招聘男性人数' },
        { type: 'text', key: 'acb21e', label: '招聘女性人数' },
        { type: 'select_s', key: 'acb246', label: '工作环境', options: this.enum_shengting.gongzuohuanjing },
        { type: 'select_s', key: 'Aac024', label: '政治面貌', options: this.enum_shengting.zhengzhimianmao },
        { type: 'text', key: 'aac034', label: '身高' },
        { type: 'text', key: 'aac035', label: '体重' },
        { type: 'text', key: 'aac036', label: '视力' },
        { type: 'select_s', key: 'aac038', label: '外语语种', options: this.enum_shengting.yuzhong },
        { type: 'select_s', key: 'aac175', label: '外语水平', options: this.enum_shengting.shuiping },
        { type: 'select_s', key: 'aac179', label: '计算机水平', options: this.enum_shengting.shuiping },
        { type: 'text', key: 'acc217', label: '从业年数' },
        { type: 'text', key: 'acb247', label: '试用期' },
        { type: 'select_s', key: 'acb243', label: '试用期月工资档次', options: this.enum_shengting.gongzidangci },
        { type: 'text', key: 'acb244', label: '其他待遇' },
        { type: 'select_s', key: 'acb228', label: '提供住宿标识', options: this.enum_shengting.shifouqita },
        { type: 'select_s', key: 'acb245', label: '提供住房公积金标识', options: this.enum_shengting.shifou },
        // { type: 'text', key: 'status_', label: '状态' },
        // { type: 'text', key: 'importError', label: '失败原因' },
      ]
    },
    formItems2_() {
      return [
        ...this.formItems2,
        { type: 'text', key: 'status_', label: '状态' },
        { type: 'text', key: 'importError', label: '失败原因' },
      ]
    },
  },
  methods: {
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      // console.log(result, this.selectData)
      let rData = {}
      let areaId = this.$refs.AreaPicker.findAreaId()
      let {
        id,
        companyName,
        aca112,
        acb22a,
        aca111,
        aac015,
        aac183,
        aac011,
        aac014,
        acb240,
        aab301,
        acb202,
        acb239,
        acb221,
        acb222,
        aac010,
        acb241,
        acb242,
        acb207,
        acb20c,
        aae004,
        aae005,
        aae397,
        aae398,
        ace751,
        ace752,
        ace760,
        aae013,
        ace762,
        acb21d,
        acb21e,
        acb246,
        Aac024,
        aac034,
        aac035,
        aac036,
        aac038,
        aac175,
        aac179,
        acc217,
        acb247,
        acb243,
        acb244,
        acb228,
        acb245,
      } = result
      if (this.isCreate) {
        rData = {
          companyName,
          aca112,
          acb22a,
          aca111,
          aac015,
          aac183,
          aac011,
          aac014,
          acb240,
          aab301,
          acb202,
          acb239,
          acb221,
          acb222,
          aac010,
          acb241,
          acb242,
          acb207,
          acb20c,
          aae004,
          aae005,
          aae397,
          aae398,
          ace751,
          ace752,
          ace760,
          aae013,
          ace762,
          acb21d,
          acb21e,
          acb246,
          Aac024,
          aac034,
          aac035,
          aac036,
          aac038,
          aac175,
          aac179,
          acc217,
          acb247,
          acb243,
          acb244,
          acb228,
          acb245,
          areaId,
        }
        // console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('新建成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        const mapList = [
          'companyName',
          'aca112',
          'acb22a',
          'aca111',
          'aac015',
          'aac183',
          'aac011',
          'aac014',
          'acb240',
          'aab301',
          'acb202',
          'acb239',
          'acb221',
          'acb222',
          'aac010',
          'acb241',
          'acb242',
          'acb207',
          'acb20c',
          'aae004',
          'aae005',
          'aae397',
          'aae398',
          'ace751',
          'ace752',
          'ace760',
          'aae013',
          'ace762',
          'acb21d',
          'acb21e',
          'acb246',
          'Aac024',
          'aac034',
          'aac035',
          'aac036',
          'aac038',
          'aac175',
          'aac179',
          'acc217',
          'acb247',
          'acb243',
          'acb244',
          'acb228',
          'acb245',
          'areaId',
        ]
        mapList.forEach(x => {
          // if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          // }
        })
        // rData.id = this.selectData.id // 绑定修改的数据id
        // console.log(rData)

        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })

        // this.$api.util_modify(this.sign, rData).then(res => {
        //   if (res.data.status == 0) {
        //     this.$message.success('修改成功')
        //     this.$refs.DialogEdit.isShowDialog = false
        //     this.$refs.DialogEdit.clearHandler()
        //     this.searchHandler()
        //   } else { this._status(res.data) }
        // })
      }
    },
    getData(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableData = _R.map(x => {
            x.status_ = ['', '未校验', '通过', '失败'][x.status]
            return x
          })
          this.pageData.total = res.data.size
          console.log(this.tableData)
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    const mapList1 = ['search','create','modify','import']
    mapList1.forEach(x => {
      this.btnShow[x] = true
    })
    const mapList = ['export','delete']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}
</style>